import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { Loading } from 'components/Loading'
import { useAppDispatch, useAppSelector } from 'store'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'
import { links } from 'utils/featureToggles'

import { PspWdCheckPaymentOptionsDto } from '../../../../../api/Wallet/Types/FullPaymentProviderDto'
import { successToast, ToastContext } from '../../../../../components/Toast/Toast'
import { fetchCountriesAction } from '../../../../../store/identity/identity.actions'
import { IdentityApiClient } from '../../../../../utils/api/identityApi'
import { useCallbackWithForceRefresh } from '../../../../../utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from '../../../../../utils/api/useFetch'
import { isEmpty } from '../../../../../utils/is-empty'
import { PaymentControlsPSPCheckStateForm } from './PaymentControlsPSPCheckStateForm'

const PaymentControlsPSPCheckStateDetailsPage = (): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const walletsApiClient = useApiClient(WalletsApiClient)

  const dispatch = useAppDispatch()
  const identityApiClient = useApiClient(IdentityApiClient)
  const countries = useAppSelector((state) => state.identity.countries)

  const setToast = useContext(ToastContext)

  const { callback, forceRefresh } = useCallbackWithForceRefresh(() => {
    return id ? walletsApiClient.getPaymentProvider(id) : Promise.resolve(null)
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading } = useFetchOne(callback)

  useEffect(() => {
    if (isEmpty(countries)) dispatch(fetchCountriesAction(identityApiClient))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (values: PspWdCheckPaymentOptionsDto) => {
    await walletsApiClient.updatePaymentProvider(values)
    setToast(successToast('PSP updated successfully.'))
    forceRefresh()
  }
  return (
    <React.Fragment>
      <Breadcrumbs
        crumbs={[
          { title: 'PSP Check State', link: links.administrationPaymentControlsPSPCheckState.url },
          { title: `${data?.paymentProvider.name ?? ''} Details`, link: '#' },
        ]}
      />
      <Loading isLoading={isLoading}>
        {data && (
          <PaymentControlsPSPCheckStateForm
            paymentProvider={data}
            countries={countries}
            onSubmit={onSubmit}
          />
        )}
      </Loading>
    </React.Fragment>
  )
}

export default PaymentControlsPSPCheckStateDetailsPage
